module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sextans/sex_vis-5f617a04f170663523257fcf800818e3.jpg";